//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
import "../no/NXObject.js";
let d=[[],[[["type"],"SetIncludeOnlyType",{},1,0],[["category"],"SetIncludeOnlyCategory",{},1,0],[[],"SetIncludeAllCategories",{},0,0],[["title"],"SetIncludeOnlyTitle",{},1,0],[["includeAlsoUnset"],"SetIncludeAlsoUnset",{},1,0],[["includeOnlyUnset"],"SetIncludeOnlyUnset",{},1,0],[["includeOnlyArrays"],"SetIncludeOnlyArrays",{},1,0],[[],"Rewind",{},0,0],[[],"Reset",{},0,0],[[],"Dispose",{},0,0]],[]];
SPLM.AttributeIterator = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AttributeIterator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;